export default {
  computed: {
    stateAmountLow: {
      get () {
        return this.filters.amount_low
      },

      set (value) {
        this.setFilterMutation({ filter: 'amount_low', value })
      }
    },

    stateAmountHigh: {
      get () {
        return this.filters.amount_high
      },

      set (value) {
        this.setFilterMutation({ filter: 'amount_high', value })
      }
    },

    stateDateFrom: {
      get () {
        return this.filters.date_from
      },

      set (value) {
        this.setFilterMutation({ filter: 'date_from', value })
      }
    },

    stateDateTo: {
      get () {
        return this.filters.date_to
      },

      set (value) {
        this.setFilterMutation({ filter: 'date_to', value })
      }
    },

    stateRegions: {
      get () {
        return this.filters.regions
      },

      set (value) {
        this.setFilterMutation({ filter: 'regions', value })
      }
    },

    stateLocations: {
      get () {
        return this.filters.locations
      },

      set (value) {
        this.setFilterMutation({ filter: 'locations', value })
      }
    },

    stateAssignedAdmin: {
      get () {
        return this.filters.assigned_admin
      },

      set (value) {
        this.setFilterMutation({ filter: 'assigned_admin', value })
      }
    },

    stateRequestedDepartment: {
      get () {
        return this.filters.requested_department
      },

      set (value) {
        this.setFilterMutation({ filter: 'requested_department', value })
      }
    },

    stateClient: {
      get () {
        return this.filters.client
      },
      set (value) {
        this.setFilterMutation({ filter: 'client', value })
      }
    },

    stateOpportunities: {
      get () {
        return this.filters.opportunities
      },

      set (value) {
        this.setFilterMutation({ filter: 'opportunities', value })
      }
    },

    stateKeywords: {
      get () {
        return this.filters.keywords
      },

      set (value) {
        this.setFilterMutation({ filter: 'keywords', value })
      }
    },

    stateStatus: {
      get () {
        return this.filters.status
      },

      set (value) {
        this.setFilterMutation({ filter: 'status', value })
      }
    },

    stateManagement: {
      get () {
        return this.filters.management
      },

      set (value) {
        this.setFilterMutation({ filter: 'management', value })
      }
    },

    stateTalent: {
      get () {
        return this.filters.talent
      },

      set (value) {
        this.setFilterMutation({ filter: 'talent', value })
      }
    },

    stateId: {
      get () {
        return this.filters.id
      },

      set (value) {
        this.setFilterMutation({ filter: 'id', value })
      }
    },

    statePipelineStatus: {
      get () {
        return this.filters.pipeline_status
      },

      set (value) {
        this.setFilterMutation({ filter: 'pipeline_status', value })
      }
    }
  }
}
